import { useEffect, useState } from "react";
import { getMember } from "../authToken";
import { EWindowEvents } from "../../@types";
export const useSessionMember = () => {
    const [isAuthenticating, setIsAuthenticating] = useState(true);
    const [sessionMember, setSessionMember] = useState();
    useEffect(() => {
        const getSessionMember = () => {
            const sessionStorageMember = getMember();
            if (sessionStorageMember) {
                setSessionMember(JSON.parse(sessionStorageMember));
            }
            else {
                // so we can return undefined if member is not found
                // instead of JSON parsing undefined
                setSessionMember(undefined);
            }
        };
        const handleLogIn = () => {
            setIsAuthenticating(false);
            getSessionMember();
        };
        const handleLoggedInAsGuest = () => {
            setIsAuthenticating(false);
            getSessionMember();
        };
        const handleLoggedInAlready = () => {
            setIsAuthenticating(false);
            getSessionMember();
        };
        const handleLoggedInWithException = () => {
            setIsAuthenticating(false);
            getSessionMember();
        };
        // get teh session member on mount
        getSessionMember();
        // get it again on the log in/out window events
        window.addEventListener(EWindowEvents.LogIn, handleLogIn);
        window.addEventListener(EWindowEvents.LogOut, getSessionMember);
        window.addEventListener(EWindowEvents.ClearSession, getSessionMember);
        window.addEventListener(EWindowEvents.LoggedInAsGuest, handleLoggedInAsGuest);
        window.addEventListener(EWindowEvents.LoggedInAlready, handleLoggedInAlready);
        window.addEventListener(EWindowEvents.LoggedInWithException, handleLoggedInWithException);
        return () => {
            window.removeEventListener(EWindowEvents.LogIn, handleLogIn);
            window.removeEventListener(EWindowEvents.LogOut, getSessionMember);
            window.removeEventListener(EWindowEvents.ClearSession, getSessionMember);
            window.removeEventListener(EWindowEvents.LoggedInAsGuest, handleLoggedInAsGuest);
            window.removeEventListener(EWindowEvents.LoggedInAlready, handleLoggedInAlready);
            window.removeEventListener(EWindowEvents.LoggedInWithException, handleLoggedInWithException);
        };
    }, []);
    return {
        isAuthenticating,
        sessionMember,
    };
};
